import { useState } from "react";
import { TextField } from "@mui/material";
import i18next from "i18next";
import PTTranslate from "./PTTranslate";

const getTranslationString = (element) => {
  return i18next.t(element.props.tk);
};

export const PTTextField = ({
  name,
  label,
  type = "text",
  required = false,
  placeholder,
  height = 56, 
  rows = 1,
  multiline = false,
  disabled = false,
  defaultValue = "",
  onChange,
  onBlur,
  error,
  helperText,
  fullWidth = true,
  ...props
}) => {
  const [value, setValue] = useState(defaultValue);
  const [touched, setTouched] = useState(false);
  
  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (onChange) {
      onChange(e);
    }
  };

  const handleBlur = (e) => {
    setTouched(true);
    if (onBlur) {
      onBlur(e);
    }
  };

  const translatedPlaceholder = placeholder 
    ? getTranslationString(<PTTranslate tk={placeholder} />) 
    : "";

  const showError = touched && error;
  
  return (
    <TextField
      name={name}
      label={label}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      fullWidth={fullWidth}
      variant="outlined"
      type={type}
      placeholder={translatedPlaceholder}
      error={Boolean(showError)}
      helperText={showError ? helperText : ""}
      required={required}
      disabled={disabled}
      multiline={multiline}
      rows={multiline ? rows : undefined}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        sx: {
          height: multiline
            ? `${Math.max(height, Math.min(120, rows * height))}px`
            : `${height}px`,
          backgroundColor: disabled ? "#e0e0e0" : "#FFFFFF",
          "& .MuiOutlinedInput-input": {
            boxSizing: "border-box",
            padding: "14px 10px", 
            "&:-webkit-autofill": {
              height: "100%",
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "4px", 
          },
        },
      }}
      sx={{
        "& .MuiFormHelperText-root": {
          marginTop: "8px",
        },
      }}
      {...props}
    />
  );
};

export default PTTextField;